"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
/**
 * Extended event emitter.
 */
class SuperEventEmitter extends events_1.EventEmitter {
    constructor() {
        super(...arguments);
        /**
         * Listeners that listen for all events.
         */
        this.allListeners = [];
    }
    /**
     * Register listener for any event.
     *
     * @param {Function} callback
     * @return {this}
     */
    onEvery(callback) {
        this.allListeners.push(callback);
        return this;
    }
    /**
     * Emits events.
     *
     * @param {string | symbol} event
     * @param args
     *
     * @throws *
     *   In case of event == "error" the error argument object will be rethrown
     *   if there are not listeners.
     *
     * @return {boolean}
     */
    emit(event, ...args) {
        this.allListeners.forEach((callback) => callback(event, ...args));
        return super.emit(event, ...args);
    }
    /**
     * @inheritDoc
     */
    listenerCount(type) {
        const count = super.listenerCount(type);
        return count + this.allListeners.length;
    }
    /**
     * Removes all listeners.
     *
     * @param {string | symbol} event
     * @return {this}
     */
    removeAllListeners(event) {
        super.removeAllListeners();
        this.allListeners = [];
        return this;
    }
}
exports.SuperEventEmitter = SuperEventEmitter;
